import React from 'react';
import { Icons as I } from '../pack-icons';
import ActivityPill from './ActivityPill';
import ThemeToggle from './ThemeToggle';
import LangSwitch from './LangSwitch';

export default function Topbar({ title, sub, right, onMobileMenuToggle, mobileNavOpen }) {
  return (
    <header className="topbar">
      {onMobileMenuToggle && (
        <button
          type="button"
          className="tb-mobile-menu"
          onClick={onMobileMenuToggle}
          aria-label={mobileNavOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileNavOpen ? 'true' : 'false'}
        >
          {mobileNavOpen ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 6h18M3 12h18M3 18h18" />
            </svg>
          )}
        </button>
      )}

      <div className="tb-l">
        {title && <div className="tb-title">{title}</div>}
        {sub && <div className="tb-sub mono">{sub}</div>}
      </div>

      <div className="tb-c">
        <ActivityPill />
      </div>

      <div className="tb-r">
        <button className="btn btn-ghost btn-sm btn-icon tb-r-search" title="Search (⌘K)" type="button">
          <I.search size={14} />
        </button>
        <ThemeToggle />
        <LangSwitch />
        {right}
      </div>
    </header>
  );
}
